import Membership from '../pages/enroll/Membership'

const membershipRoutes = [{index: true, element: <Membership />}]

export default membershipRoutes
